<template>

<div v-if="item.label != undefined">

  <label>

    <input
      :id="item.id"
      :name="item.name"
      :type="item.type"
      :required=item.required>

    <Small :text="$t(item.label)"/>

  </label>

</div>
<div v-else>

  <input
    :id="item.id"
    :name="item.name"
    :type="item.type"
    :required=item.required
    :placeholder="$t(item.placeholder)">

</div>

</template>

<script>
import Small from '../texts/Small.vue'

export default {
  name: 'Input',
  props: {
    item: Object
  },
  components: {
    Small
  }
}
</script>

<style lang="scss" scoped>
input {
  width: calc(100% - 50px);
  color: #bac6e6;
  font-size: 24px;
  font-family: 'Poppins-Medium';
  background-color: inherit;
  border: 1px solid #bac6e6;
  border-radius: 50px;
  padding: 15px 25px;
  margin: 10px 0;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: #bac6e6;
    opacity: 1;
  }

  &:-ms-input-placeholder {
    color: #bac6e6;
  }

  &::-ms-input-placeholder {
    color: #bac6e6;
  }
}

label {
  input {
    width: 5%;
  }

  div {
    width: 92%;
    display: inline-block;
    color: #bac6e6;
    vertical-align: text-top;
    margin-left: 2%;
  }
}

::v-deep label div a {
  text-decoration: underline;
}
</style>
